export const PartnerPayoutRecordStage = {
  BOOKING_COMPLETED: 'BOOKING_COMPLETED',
  BOOKING_PAID: 'BOOKING_PAID',
};

export const PartnerTransactionStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

//For Transfer Editor
export const LandlordCommissionCurrencies = {
  CNY: 'CNY',
  HKD: 'HKD',
  USD: 'USD',
  GBP: 'GBP',
  AUD: 'AUD',
  EUR: 'EUR',
  CAD: 'CAD',
  NZD: 'NZD',
  ZAR: 'ZAR',
  JPY: 'JPY',
  MXN: 'MXN',
  DKK: 'DKK',
  AED: 'AED',
  CHF: 'CHF',
  SGD: 'SGD',
  PLN: 'PLN',
  KRW: 'KRW',
  SEK: 'SEK',
  COP: 'COP',
  CLP: 'CLP',
  CZK: 'CZK',
  TRY: 'TRY',
};

export const PAYMENT_PREFERENCE = {
  NOT_SPECIFIC: 'Not Specific',
  ONLINE: 'Online',
  OFFLINE: 'Offline',
};
